import React from 'react'
import AddSupplierContainer from '../../../../../Components/UserPart/AddUser/AddSupplierContainer/AddSupplierContainer'
import Layout from '../../../Layout'

const AddSupplier = () => {
  return (
    <Layout>
        <AddSupplierContainer/>
    </Layout>
  )
}

export default AddSupplier